import { hooks, mui, React } from '_core';

import { DraftParams } from './types';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;
  hasBenchmark: boolean;
};

const Form = ({ params, setParams, hasBenchmark }: FormProps) => {
  const [showTargetWeight, setShowTargetWeight] = React.useState(params.showTargetWeight || false);
  const uiStyles = hooks.useUiStyles();

  React.useEffect(() => {
    const data = {
      ...params,
      showTargetWeight: showTargetWeight,
    } as DraftParams;

    setParams(data);
  }, [showTargetWeight]);

  if (!hasBenchmark || !params.isBasket) return null;

  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <mui.core.Box mt={3}>
        <mui.core.FormControlLabel
          control={
            <mui.core.Switch
              size="small"
              checked={showTargetWeight}
              onChange={() => setShowTargetWeight(!showTargetWeight)}
            />
          }
          label="Show target weight returns"
        />
      </mui.core.Box>
    </mui.core.Box>
  );
};

export default Form;
